import React, { useState } from 'react';

const CapsuleSelectCell = ({ options, value, row, table }) => {

  const handleChange = (event) => {
    if (row.original.capsule.id === event.target.value) return
    const newValue = parseInt(event.target.value);
    const name = options.find(capsule => capsule.id === newValue).name
    console.log(row.index, newValue, name)
    table.options.meta.updateCapsuleOnDivide(row.original.mixture.id, { id: newValue, name: name, databaseId: null });
  };


  return (
    <select value={value} onChange={handleChange}>
      {options.map(option => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default CapsuleSelectCell;
